import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useSelector } from 'react-redux';
import { advertisementsClickService, getAdvertisementsService } from '../services/apiServices';
import { isMobile } from 'react-device-detect';
import { isVideo } from '../utilities';
import ReactPlayer from 'react-player';
import { getDeviceInfo } from '../utilities';

const settings = {
  infinite: true,
  speed: 500,
  slidesToScroll: 1,
  slidesToShow: 1,
  lazyLoad: true,
  initialSlide: 0,
  arrows: isMobile ? false : true,
  dots: true,
  autoplay: true,
  swipeToSlide: true,
  swipe: true,
  autoplaySpeed: 5000,
  pauseOnHover: true,
  infinite: true,
  focusOnSelect: true,
};
 
function Advertisement() {
  const { domainDetails} = useSelector((state) => state.listings);
  const [ adsList, setAdsList] = useState([]);
  
  useEffect(() => {
    if(domainDetails.id)  {
        fetchAds(domainDetails.id);
      }
  }, [domainDetails]);

  const fetchAds = (orgId) => {
    getAdvertisementsService(orgId).then((response) => {
      console.log(response)
      setAdsList(response)
    }).catch((error) => console.log(error));
  };

  const handleAdvertisementClick = (ad) =>{
    if (ad.contentUrl) {
      window.open(ad.contentUrl, '_blank');
    }
    advertisementsClickService(domainDetails.id,ad.id,getDeviceInfo())
  }

  const config = {
    file: {
      attributes: {
        controlsList: 'fullscreen',
      },
    },
  };
  
  return (adsList && adsList.length) > 0 ? (
    <section id='banners1'>
      <Slider {...settings}>
        {adsList.map((items) => {
          return (
            <div key={items.id} onClick={() => items.advertisement.contentUrl ? handleAdvertisementClick(items.advertisement) : {}}>
              {items.advertisement.contentMediaType === 2 ? (
            <ReactPlayer url={items.advertisement.contentMediaUrl} playing={true} controls={true} muted={true} config={config} playsinline={true} width={'100%'} />
          ):(
              <figure style={items.advertisement.contentUrl ? {width: '100%', cursor:'pointer'} : {width: '100%'}}>
                <img  src={items.advertisement.contentMediaUrl} alt={items.title}  />
              </figure>
              )}
            </div>
          );
        })}
      </Slider>
    </section>
  ) : (
    ''
  );
}
export default Advertisement;